// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"1f6fc6b4","157":"63392ff4","158":"071f2a4f","213":"fb7ba641","320":"80d8b0f9","427":"72fab61b","455":"ed8501f6","544":"bfcb5abd","764":"ce8eff63","857":"d705bb42","905":"3ccca7c3","934":"f0ac5136"}[chunkId] + ".chunk.js";
};